<template>
    <div class="spinner_wrap" :class="{ full: props.isFullPage }">
        <div
            class="spinner"
            :style="{
                width: `${props.isFullPage ? props.spinnerSize * 1.5 : props.spinnerSize}px`,
                height: `${props.isFullPage ? props.spinnerSize * 1.5 : props.spinnerSize}px`,
                border: `${props.thickness}px solid ${lineColor}`,
                borderBottomColor: spinnerColor,
                animationDuration: `${props.speed}s`,
            }"
        ></div>
    </div>
</template>

<script setup lang="ts">
    import { computed, onMounted, onUnmounted } from "@/BaseComponent";
    interface Props {
        spinnerSize?: number; // 스피너 크기
        thickness?: number; // 스피너 굵기
        borderColor?: string; // 스피너 배경 색상
        isFullPage?: boolean; // 전체화면 사용 여부
        color?: string; // 스피너 내부 색상
        speed?: number;
    }

    const props = withDefaults(defineProps<Props>(), {
        spinnerSize: 48,
        thickness: 5,
        borderColor: "",
        fullSize: false,
        color: "",
        speed: 0.8,
    });

    onMounted(() => {
        if (props.isFullPage) document.body.style.overflow = "hidden";
    });

    onUnmounted(() => {
        if (props.isFullPage) document.body.style.overflow = "";
    });

    const spinnerColor = computed(() => {
        if (!props.color) return "#31A6D8"; // 기본 값
        const s = new Option().style;
        s.color = props.color;

        return s.color ? s.color : "#31A6D8";
    });

    const lineColor = computed(() => {
        if (!props.borderColor) return "#e2e2e2"; // 기본 값
        const s = new Option().style;
        s.color = props.borderColor;

        return s.color ? s.color : "#e2e2e2";
    });
</script>

<style scoped>
    .spinner {
        margin: 0 10px;
        border-radius: 50%;
        display: inline-block;
        box-sizing: border-box;
        opacity: 1;
        animation: rotation 0.8s linear infinite;
    }

    @keyframes rotation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .spinner_wrap {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .spinner_wrap.full {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 99999;
    }
</style>
